import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/AIML/ShowQuantAnalysisDetails";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ShowQuantAnalysisDetailsMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="ShowQuantAnalysisDetails">
      <MobileNotice page="ShowQuantAnalysisDetails" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default ShowQuantAnalysisDetailsMobile;